<template>
  <div class="audiences-selector">
    <div class="accounts">
      <div class="header">账号</div>

      <div class="row-list">
        <div
          class="row-item"
          :class="{ active: ac.id === activeAccount }"
          v-for="ac in accounts"
          :key="ac.id"
          @click="onAccountItemClick(ac)"
        >
          <span>{{ ac.name || ac.adAccount }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>

    <div class="table">
      <el-table class="common-el-table-styles" :data="tableData" height="260" style="width: 100%">
        <el-table-column prop="groupName" show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <div class="title-header">
              <span :class="scope.a">选定人群</span>
              <el-input class="filter" v-model="searchValue" clearable size="mini" placeholder="输入关键字搜索" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="groupId" label="ID" width="110"> </el-table-column>
        <slot>
          <el-table-column prop="groupTypeDesc" width="90" label="属性"> </el-table-column>
        </slot>
        <el-table-column prop="address" width="80">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a"><span>定向</span> <el-checkbox v-model="includesAll" @change="onIncludeAllChange"></el-checkbox></div>
          </template>
          <template slot-scope="{ row }">
            <el-radio @change="onRadioChange" :disabled="row.includesDisabled" v-model="row.check" :label="1">&ensp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="address" width="80">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a"><span>排除</span> <el-checkbox v-model="excludesAll" @change="onExcludeAllChange"></el-checkbox></div>
          </template>
          <template slot-scope="{ row }">
            <el-radio @change="onRadioChange" :disabled="row.excludesDisabled" v-model="row.check" :label="2">&ensp;</el-radio>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="results">
      <div class="header">
        <div>
          <span class="result-tab" :class="{ active: activeTab === 'includes' }" @click="activeTab = 'includes'">
            定向({{ currentAccount.includes.length }})
          </span>
          <span class="result-tab" :class="{ active: activeTab === 'excludes' }" @click="activeTab = 'excludes'">
            排除({{ currentAccount.excludes.length }})
          </span>
        </div>
        <span class="clear" @click="removeAll">清空</span>
      </div>

      <div class="row-list">
        <div class="row-item" v-for="res in results" :key="res.groupId">
          <span>{{ res.groupName }}</span>
          <i @click="removeItem(res)" class="remove el-icon-error"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @usage: data [{
*   check: null,
    includesDisabled: false,
    excludesDisabled: false,
    groupId: 1, // 人群包id
    groupName: 'name', // 人群包名
    groupTypeDesc: '人群属性' || '未知'
  }]
  快手人群包
  百度人群包
  腾讯广告人群包

  @events:  @change
  @events:  @account-change
 */

/**
 * @description: 人群包定向标记
 */
const RADIO_INCLUDE = 1
/**
 * @description: 人群包排除标记
 */
const RADIO_EXCLUDE = 2
export default {
  props: {
    /**
     * @description: 全部账号的model
     * @return {
     *  [accountId]: {
            accountId: 123,
            includes: [],
            excludes: []
        }
     * }
     */
    value: {
      type: Object,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    accounts: {
      type: Array,
      required: true
    }
  },
  computed: {
    /**
     * @description: 返回当前账号的model，适用于多账号场景
     * @return {
     *    accountId: 123,
          includes: [],
          excludes: []
        }
     */
    currentAccount() {
      const acc = this.value[this.activeAccount]

      if (!acc) {
        return {
          includes: [],
          excludes: []
        }
      }
      return acc
    },
    tableData() {
      const str = this.searchValue.toLowerCase()
      const { includes, excludes } = this.currentAccount

      // 关键词搜索
      const resList = this.data
        .filter((row) => !str || row.groupName.toLowerCase().includes(str))
        .map((row) => {
          let checkLabel = null
          if (includes.includes(row.groupId)) checkLabel = RADIO_INCLUDE
          if (excludes.includes(row.groupId)) checkLabel = RADIO_EXCLUDE

          return { ...row, check: checkLabel }
        })

      return resList
    },
    results() {
      return this.selected[this.activeTab]
    },
    includesAll: {
      get() {
        return this.currentAccount.includes.length === this.tableData.length
      },
      set(v) {
        this.onIncludeAllChange(v)
      }
    },
    excludesAll: {
      get() {
        return this.currentAccount.excludes.length === this.tableData.length
      },
      set(v) {
        this.onExcludeAllChange(v)
      }
    }
  },

  data() {
    const [account] = this.accounts
    return {
      selected: { includes: [], excludes: [] },
      searchValue: '',
      activeTab: 'includes',
      activeAccount: account.id
    }
  },
  watch: {
    // 绑定数据变化时重新检查已选项，回显已选结果
    currentAccount() {
      this.getSelected()
    },
    // 列表数据变化时重新检查已选项，回显已选结果
    data() {
      this.getSelected()
    }
  },

  created() {
    this.getSelected()
  },

  methods: {
    onAccountItemClick(ac) {
      this.activeAccount = ac.id
      this.$emit('account-change', ac.id)
    },

    onIncludeAllChange(v) {
      if (v) {
        this.updateModel({
          accountId: this.activeAccount,
          excludes: [],
          includes: this.tableData.map((row) => ({ ...row, check: RADIO_INCLUDE }))
        })
      } else {
        this.updateModel({
          accountId: this.activeAccount,
          excludes: [],
          includes: []
        })
      }
    },

    onExcludeAllChange(v) {
      if (v) {
        this.updateModel({
          accountId: this.activeAccount,
          excludes: this.tableData.map((row) => ({ ...row, check: RADIO_EXCLUDE })),
          includes: []
        })
      } else {
        this.updateModel({
          accountId: this.activeAccount,
          excludes: [],
          includes: []
        })
      }
    },

    /**
     * @description: 更新v-model
     */
    onRadioChange(v) {
      this.$nextTick(() => {
        const res = this.getSelected()
        const v = {
          accountId: this.activeAccount,
          ...res
        }
        this.updateModel(v)
      })
    },

    getSelected() {
      const checkedList = this.tableData.filter((row) => row.check)
      const includes = []
      const excludes = []

      checkedList.forEach((s) => {
        if (s.check === RADIO_INCLUDE) {
          includes.push(s)
        }

        if (s.check === RADIO_EXCLUDE) {
          excludes.push(s)
        }
      })
      this.selected = {
        includes,
        excludes
      }
      return this.selected
    },

    removeItem(item) {
      const prop = [null, 'includes', 'excludes'][item.check]

      if (prop) {
        const res = this.getSelected()
        const newValue = {
          accountId: this.activeAccount,
          ...res
        }
        newValue[prop] = newValue[prop].filter((row) => row.groupId !== item.groupId)

        this.selected = { includes: newValue.includes, excludes: newValue.excludes }
        this.updateModel(newValue)
      } else {
        console.log('removeItem output: 单条人群包删除错误', item)
      }
    },

    removeAll() {
      this.selected = { includes: [], excludes: [] }

      const newValue = {
        accountId: this.activeAccount,
        includes: [],
        excludes: []
      }
      this.updateModel(newValue)
    },

    updateModel(v) {
      const { includes, excludes, accountId } = v

      const newModel = {
        accountId,
        includes: includes.map((row) => row.groupId),
        excludes: excludes.map((row) => row.groupId)
      }

      // 多账号的数据结构
      this.$emit('input', newModel)
      // 当前修改账号的数据结构
      this.$emit('change', newModel)
    }
  }
}
</script>
<style>
.el-tooltip__popper {
  z-index: 11111 !important;
}
</style>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.audiences-selector {
  border: 1px solid #dee4f5;
  border-radius: 4px;
  display: flex;

  .header {
    line-height: 34px;
    font-size: 12px;
    background: #fafbfe;
    border-bottom: 1px solid #dee4f5;
    padding: 0 10px;
    font-weight: 700;
  }

  .accounts {
    min-width: 220px;
    border-right: 1px solid #dee4f5;
  }

  .row-list {
    height: 225px;
    overflow: auto;
    .row-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      cursor: pointer;
      font-size: 12px;
      margin-bottom: 0;

      > span {
        display: block;
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .remove {
        display: none;
      }

      &:hover,
      &.active {
        background: #eee;
      }

      &:hover {
        .remove {
          display: inline-block;
        }
      }
    }
  }

  ::v-deep .table {
    flex: 1;

    position: relative;

    .title-header {
      display: flex;
      align-items: center;
      width: 100%;
      > span {
        min-width: 60px;
      }

      .filter {
        flex: 1;
      }
    }

    .el-table {
      thead th {
        background-color: #fafbfe !important;
      }
    }
  }
  .results {
    border-left: 1px solid #dee4f5;
    // min-width: 310px;
    flex-basis: 20%;

    .header {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      font-weight: normal;
      .clear {
        color: $primary-color;
      }
    }

    .result-tab {
      cursor: pointer;
      margin-right: 10px;

      &.active {
        color: $primary-color;
        padding-bottom: 3px;
        border-bottom: 2px solid $primary-color;
      }
    }
  }
}
</style>
